<template>
    <div class="animate__slow animate__infinite animate__flash bg-slate-200 content-['']"></div>
</template>

<script setup lang="ts">

</script>

<style scoped></style>